import { BotIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Bot = /* @__PURE__ */ createIcon(BotIcon, 'Bot');
